<button
    (click)="goToHit()"
    [disabled]="!currentClient || !vvvo"
    mat-icon-button
    matTooltip="HIT in neuen Tab &ouml;ffnen und PIN in Zwischenablage kopieren"
    style="margin: 0px; padding: 0px"
>
    <mat-icon>launch</mat-icon>
</button>
